import { useMutation } from '@tanstack/react-query';

import { GatewayFormSchemaValues } from 'src/features/gateway/utils/formSchema';
import { Gateway } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/gateway/:gatewayId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: GatewayFormSchemaValues;
    gatewayId: string;
    parkingId: string;
}
const mutationFn = ({ gatewayId, parkingId, data }: DTO): Promise<Gateway> => {
    return axios.put(formatResourcePath(RESOURCE, { gatewayId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateGateway };
